import type { JSX } from 'react'
import type { ISearchInputProps } from '../SearchInput'

import { ActionButtonColors } from 'atoms/ActionButton'
import { ButtonFonts, ButtonIconSizes } from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import {
  InputActionButtonPosition,
  InputCaretColors,
  InputFontColors,
  InputFonts,
  InputHeight,
  InputMargins,
  InputNames,
  InputPaddings,
} from 'atoms/Input'
import { FIXED_INDENTS } from 'vars/index'
import { SearchInput } from '../SearchInput'

export interface ISearchInputWithDeleteButtonProps extends ISearchInputProps {}

export const SearchInputWithDeleteButton = ({
  name = InputNames.Search,
  value,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  font = InputFonts.Body4,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  icon = IconNames.close,
  iconSize = ButtonIconSizes.small,
  iconFont = ButtonFonts.Button1,
  actionButtonPosition = InputActionButtonPosition.Right,
  inputLabelWidth = '100%',
  inputWrapperWidth = '100%',
  height = InputHeight.SIZE_10,
  paddings = InputPaddings.SIZE_60,
  inputLabelMargins = InputMargins.SIZE_10,
  actionButtonColorDefault = ActionButtonColors.COLOR_MAIN_DEFAULT,
  actionButtonColorHovered = ActionButtonColors.SURFACE_LIGHT_2,
  actionButtonColorPressed = ActionButtonColors.COLOR_MAIN_PRESSED,
  actionButtonPaddings = [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_50,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_30,
  ],
  autoComplete = 'off',
  caretColor = InputCaretColors.TEXT_ICON_SECONDARY,
  onChange,
  onClick,
  ...rest
}: ISearchInputWithDeleteButtonProps): JSX.Element => (
  <SearchInput
    name={name}
    value={value}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    font={font}
    colorDefault={colorDefault}
    icon={icon}
    iconFont={iconFont}
    iconSize={iconSize}
    actionButtonPosition={actionButtonPosition}
    inputLabelWidth={inputLabelWidth}
    inputWrapperWidth={inputWrapperWidth}
    height={height}
    paddings={paddings}
    inputLabelMargins={inputLabelMargins}
    actionButtonColorDefault={actionButtonColorDefault}
    actionButtonColorHovered={actionButtonColorHovered}
    actionButtonColorPressed={actionButtonColorPressed}
    actionButtonPaddings={actionButtonPaddings}
    autoComplete={autoComplete}
    caretColor={caretColor}
    onChange={onChange}
    onClick={onClick}
    {...rest}
  />
)
